import { firebaseProjectId } from "../services/FireBase.js";

export const DEV_PROJECT_ID = "dev-voorraad";
export const PRODUCTION_PROJECT_ID = "voorraadsysteem-bbf99";

const isEnabled = (value) => String(value || "").trim().toLowerCase() === "true";

export function resolveRuntimeFeatures({
  projectId,
  upgradedWorkflow,
  salesAssociationReports,
} = {}) {
  const isDevelopmentProject = projectId === DEV_PROJECT_ID;
  const isProductionProject = projectId === PRODUCTION_PROJECT_ID;

  return Object.freeze({
    isDevelopmentProject,
    crateLookupScannerEnabled: isDevelopmentProject || isProductionProject,
    customerOrderWorkflowEnabled: isDevelopmentProject || isProductionProject,
    historyDashboardEnabled: isDevelopmentProject || isProductionProject,
    parcelManagementEnabled: isDevelopmentProject || isProductionProject,
    salesAssociationReportsEnabled:
      isDevelopmentProject || isEnabled(salesAssociationReports),
    upgradedWorkflowEnabled:
      isDevelopmentProject || isProductionProject || isEnabled(upgradedWorkflow),
  });
}

export const runtimeFeatures = resolveRuntimeFeatures({
  projectId: firebaseProjectId,
  upgradedWorkflow: process.env.REACT_APP_UPGRADED_WORKFLOW,
  salesAssociationReports: process.env.REACT_APP_SALES_ASSOCIATION_REPORTS,
});

export const upgradedWorkflowEnabled =
  runtimeFeatures.upgradedWorkflowEnabled;

export const crateLookupScannerEnabled =
  runtimeFeatures.crateLookupScannerEnabled;

export const customerOrderWorkflowEnabled =
  runtimeFeatures.customerOrderWorkflowEnabled;

export const historyDashboardEnabled =
  runtimeFeatures.historyDashboardEnabled;

export const salesAssociationReportsEnabled =
  runtimeFeatures.salesAssociationReportsEnabled;
